import React from 'react'
import { IconButton } from '@mui/material'
import { makeStyles } from '@mui/styles'
import DeleteIcon from '@mui/icons-material/Delete'

interface DeleteIconButtonProps {
  isDisabled: boolean
  onClick: any
}

const useStyles = makeStyles({
  root: {
    '&:hover, &.Mui-focusVisible': { color: '#f64541' }
  }
})

export const DeleteIconButton: React.FC<DeleteIconButtonProps> = ({
  isDisabled,
  onClick
}) => {
  const classes = useStyles()
  return (
    <IconButton
      aria-label='delete'
      classes={{
        root: classes.root
      }}
      disabled={isDisabled}
      onClick={onClick}
    >
      <DeleteIcon />
    </IconButton>
  )
}
